import { render, staticRenderFns } from "./CorporateStep2.vue?vue&type=template&id=3910484e&scoped=true&"
import script from "./CorporateStep2.vue?vue&type=script&lang=js&"
export * from "./CorporateStep2.vue?vue&type=script&lang=js&"
import style0 from "./CorporateStep2.vue?vue&type=style&index=0&id=3910484e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910484e",
  null
  
)

export default component.exports